import { render, staticRenderFns } from "./BuyReportOnePersonComponent.vue?vue&type=template&id=5180e36e&"
import script from "./BuyReportOnePersonComponent.vue?vue&type=script&lang=js&"
export * from "./BuyReportOnePersonComponent.vue?vue&type=script&lang=js&"
import style0 from "./BuyReportOnePersonComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports